import React, { useState, useEffect } from "react";

import { Edit as EditIcon, Eye, DownArrow } from "icons";

import { Table, Tooltip, Dropdown, Button } from "clearsense-ui/components";
import { EmptyState } from "components/Common";
import PermissibleWrapper from "components/Common/PermissibleWrapper";

import { NPI_RECORDS_LIST_COLUMNS } from "./constants";
import Edit from "./Edit";

const NPIRecordsList = ({
  npiRecords,
  searchParams,
  userPermissions,
  entities,
  handleEditNPI,
  setIsViewMode,
  handleSearch,
}) => {
  const [currentEntityID, setCurrentEntityID] = useState("");
  useEffect(() => {
    setCurrentEntityID("");
  }, [searchParams]);

  if (npiRecords.length === 0) {
    return (
      <>
        {!currentEntityID ? (
          <EmptyState
            mainText="No Records Found"
            illustration={<span></span>}
            actionBlock={
              <Dropdown
                customTarget={
                  <Button
                    label="Create Entity Item"
                    className="px-4 space-x-2"
                    icon={() => <DownArrow size={12} />}
                    iconPosition="right"
                  />
                }
              >
                {entities
                  .filter(({ template_id }) => template_id)
                  .map(entity => (
                    <li
                      key={entity.name}
                      onClick={() => setCurrentEntityID(entity.id)}
                    >
                      {entity.name}
                    </li>
                  ))}
              </Dropdown>
            }
          />
        ) : (
          <Edit
            currentEntityID={currentEntityID}
            npiRecords={npiRecords}
            searchParams={searchParams}
            userPermissions={userPermissions}
            updateData={handleEditNPI}
            handleSearch={handleSearch}
          />
        )}
      </>
    );
  }

  return (
    <div>
      <Table
        columnData={[
          ...NPI_RECORDS_LIST_COLUMNS,
          {
            key: "actions",
            width: 150,
            fixed: "right",
            render: (_, record) => (
              <div className="flex space-x-4">
                <PermissibleWrapper
                  currentPermissions={userPermissions}
                  acceptablePermissions="read"
                >
                  <Tooltip position="top" content="View" delay={[800, 0]}>
                    <div>
                      <Eye
                        size={20}
                        className="cursor-pointer hover:text-primary-shade"
                        onClick={() => {
                          setIsViewMode(true);
                          handleEditNPI({
                            npi: record.entity_key,
                            cdt_run_date: "placeholder",
                            entity_id: record.provider_manager_entity_id,
                            entity_item_id: record.id,
                          });
                        }}
                      />
                    </div>
                  </Tooltip>
                </PermissibleWrapper>
                <PermissibleWrapper
                  currentPermissions={userPermissions}
                  acceptablePermissions="update"
                >
                  <Tooltip position="top" content="Edit" delay={[800, 0]}>
                    <div>
                      <EditIcon
                        size={20}
                        className="cursor-pointer hover:text-primary-shade"
                        onClick={() => {
                          setIsViewMode(false);
                          handleEditNPI({
                            npi: record.entity_key,
                            cdt_run_date: "placeholder",
                            entity_id: record.provider_manager_entity_id,
                            entity_item_id: record.id,
                          });
                        }}
                      />
                    </div>
                  </Tooltip>
                </PermissibleWrapper>
              </div>
            ),
          },
        ]}
        rowData={npiRecords.map((record, idx) => ({ key: idx, ...record }))}
        allowRowClick={false}
      />
    </div>
  );
};

export default NPIRecordsList;
